import React, { useState, useEffect } from 'react';
import WorklistDashboardSection from './WorklistDashboardSection';
import { getDashboardDetails, requestInfo } from '../../../../services/modulesServices/userManagement.api';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../../redux/authSlice';
import GMDashboardSection from './GMDashboardSection';
import HeaderComponent from '../../../../components/header/Header.component';
import MDDashboardSection from './MDDashboardSection';
import Loading from '../../../../components/portalComponents/Loading.component';
import { tableData } from '../types';
import { useNavigate } from 'react-router';
import GenericActionTable from '../../../../components/moduleCommonFormik/GenericActionTable';
import FooterComponent from '../../../../components/portalComponents/Footer.component';
import { getFinancialYears } from '../../../../utils/utils';
import { DASHBOARD_TABLE_COLUMNS_INBOX } from '../UserManagement.const';

function Dashboard() {
    const [dashboardDetails, setDashboardDetails] = useState<any>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [tableData, setTableData] = useState<any>(null);

    const userData = useSelector(selectUser);
    const navigate = useNavigate();

    const currentUserAssignedDesignation = JSON.parse(localStorage.getItem('currentUserAssignment') || '{}').designation;

    const financialDates = (finYear: any) => {
        const years = finYear?.split('-');
        const startYear = years[0];
        const endYear = '20' + years[1];
        const fromDate = new Date(`${startYear}-04-01`);
        const toDate = new Date(`${endYear}-03-31`);
        fromDate.setHours(0, 0, 0, 0);
        toDate.setHours(23, 59, 59, 999);
        return {
            fromDate: fromDate?.getTime(),
            toDate: toDate?.getTime()
        };
    };

    useEffect(() => {
        setIsLoading(true);
        const options: any = getFinancialYears(1);
        const finDates = financialDates(options?.[0]?.value);
        const payload = { RequestInfo: requestInfo(), fromDate: finDates?.fromDate, toDate: finDates?.toDate, designationCode: currentUserAssignedDesignation?.code };
        getDashboardDetails(payload)
            .then(res => {
                setDashboardDetails(res.data);
                setIsLoading(false);
            })
            .catch(err => {
                console.log(err);
                setIsLoading(false);
            });
    }, [userData]);

    const handleRowClick = (rowData: tableData) => {
        // Use useNavigate to navigate to the details page and pass data
        const url = rowData.navUrl;
        if (url) {
            navigate(url, { state: { rowData } });
        }
    };

    const onChange = async (e: any) => {
        setIsLoading(true);
        const finDates = financialDates(e.value);
        const payload = { RequestInfo: requestInfo(), fromDate: finDates?.fromDate, toDate: finDates?.toDate, designationCode: currentUserAssignedDesignation?.code };
        getDashboardDetails(payload)
            .then(res => {
                setDashboardDetails(res.data);
                setIsLoading(false);
            })
            .catch(err => {
                console.log(err);
                setIsLoading(false);
            });
    };

    // useEffect(() => {
    //     (async () => {
    //         await documentDownloadV2(['a1dd0ccc-8052-46e8-a288-0f68614dace1']);
    //     })();
    // }, []);

    console.log('dashboardDetails', dashboardDetails);

    return (
        <>
            {!!isLoading && <Loading />}
            <HeaderComponent />
            <div className='m-auto mx-5 px-5'>
                {dashboardDetails?.worklists?.length ? <WorklistDashboardSection dashboardDetails={dashboardDetails} setTableData={setTableData} tableData={tableData} /> : <></>}
                {dashboardDetails?.cards?.length ? <GMDashboardSection dashboardDetails={dashboardDetails} setTableData={setTableData} tableData={tableData} /> : <></>}
                {dashboardDetails?.gidcCards?.length ? <MDDashboardSection dashboardDetails={dashboardDetails} setTableData={setTableData} tableData={tableData} onChange={onChange} /> : <></>}
                {dashboardDetails?.gidcWorklists?.length ? <WorklistDashboardSection dashboardDetails={dashboardDetails} setTableData={setTableData} tableData={tableData} /> : <></>}

                {tableData ? (
                    <div className='mt-5'>
                        <GenericActionTable columns={DASHBOARD_TABLE_COLUMNS_INBOX} rowData={tableData} additionalMethod={handleRowClick} searchBarPlaceholder='SEARCH_BY'></GenericActionTable>
                    </div>
                ) : (
                    <></>
                )}
            </div>
            <div className='mt-5'>
                <FooterComponent onlyCopyright={true} />
            </div>
        </>
    );
}

export default Dashboard;
